<template>
  <!-- <Menu mode="horizontal" :active-name="$route.meta.url" class="nav"> -->
  <Menu mode="horizontal" :active-name="$route.meta.url" @on-select="getRoute" class="nav">
    <template v-for="(item, index) in menuList">
      <MenuItem :name="item.meta.url" v-if="!item.meta.list" :to="item.meta.url">
      <span class="pr">
        {{ item.meta.name }}
        <i class="new_style" v-if="item.meta.newStatus"></i>
      </span>
      </MenuItem>

      <Submenu :name="item.meta.url" v-else class="childMenu">
        <template slot="title">
          <router-link :to="item.meta.url" class="pr">
            <img class="dl wh19 br50b va-4" :src="headerImg()" alt="">
            {{ item.meta.name }}
            <i class="new_style" v-if="item.meta.newStatus"></i>
          </router-link>
        </template>

        <MenuItem class="tl" v-for="(menuChild, childIndex) in item.meta.list" :name="menuChild.meta.url" v-show="menuChild.meta.name != '快贴代理人' || (menuChild.meta.name == '快贴代理人' && $store.state.discountRouterIsShow)" :key="childIndex" :to="menuChild.meta.url">
        {{ menuChild.meta.name }}
        </MenuItem>
      </Submenu>
    </template>

  </Menu>
</template>

<script>
import store from '@/store/store';
import { mainRouter } from "@/router/routes";

export default {
  store, // 引用
  mainRouter,
  inject: ['reload'],
  data () {
    return {
      menuList: mainRouter[0].children,
    }
  },
  created () {
    console.log("nav", this.menuList);
  },
  methods: {
    getRoute (name) {
      if (
        (name == '/ApplicationDiscount' && this.$route.path == '/ApplicationDiscount') ||
        (name == '/BusinessTicketDiscount' && this.$route.path == '/BusinessTicketDiscount')
      ) {
        this.reload();
      }
      //  else {
      //   this.$router.push(name);
      // }
    }
  },
  watch: {
    /*'$store.state.discountRouterIsShow'(nval, oval) {
      console.log("show变化", nval);
    }*/
  }
}
</script>

<style lang="less">
@import '../../../my-theme/index.less';
.nav-list {
  padding: 0px 20px;
  line-height: 60px;
  float: left;
  position: relative;
  cursor: pointer;
  transition: all 0.3s;
}
.nav-list-active {
  color: @dp-c-menu-active;
}
.nav-list-active:after {
  content: '';
  position: absolute;
  width: 100%;
  height: 3px;
  bottom: 0px;
  left: 0px;
  background-color: @dp-bg-menu-active-bottom;
}
.nav .childMenu.ivu-menu-submenu:hover a {
  color: @dp-c-menu-active;
}
.nav .ivu-menu-submenu-title a {
  color: #657180;
}
.nav .ivu-menu-submenu-title .router-link-active {
  color: @dp-c-menu-active;
}
.nav .ivu-menu-submenu.ivu-menu-item-active a {
  color: @dp-c-menu-active !important;
}
.nav .new_style {
  width: 43px;
  height: 22px;
  display: inline-block;
  background: url('../../assets/img/home/new@2x.png') no-repeat center center;
  background-size: contain;
  color: #27aef0;
  position: absolute;
  right: -41px;
  top: -19px;
}
</style>



// WEBPACK FOOTER //
// src/components/module/Nav.vue